import React from 'react';
import PropTypes from 'prop-types';
import Conditional from '@wikom/react-conditional';
import { isGuest } from '../helpers/menuHelpers';
import UserNavigation from './UserNavigation';
import GuestNavigation from './GuestNavigation';
var Navigation = function (_a) {
    var user = _a.user, betrieb = _a.betrieb;
    return (React.createElement("div", null,
        React.createElement(Conditional, { condition: function () { return (!isGuest(user)); } },
            React.createElement(UserNavigation, { user: user, betrieb: betrieb })),
        React.createElement(Conditional, { condition: function () { return isGuest(user); } },
            React.createElement(GuestNavigation, null))));
};
Navigation.propTypes = {
    user: PropTypes.object.isRequired,
    betrieb: PropTypes.string
};
export default Navigation;
